import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const CommunityPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "community-page" */'./community.page.js'),
	modules: ['./community.page.js'],
	webpack: () => [require.resolveWeak('./community.page.js')],
	loading: CustomLoadableLoading,
});

export default CommunityPageAsync;
